'use strict';
var parent = require('../../es/reflect/set');

module.exports = parent;
